<ds-paper elevation="elevation_none" borderRadius="radius_S" outline="outlined" insidePaddingTop="top-spacing_L"
  insidePaddingBottom="bottom-spacing_L" insidePaddingLeft="left-spacing_XL" insidePaddingRight="right-spacing_XL"
  id="accounts-info-main-container">
  <div class="header-container">
    <typography id="detailsTitle" variant="mat-headline-6" weight="bold">
      {{appStrings.details}}
    </typography>
    <ds-divider></ds-divider>
  </div>
  <div class="info-container" id="infoContainer">
    <div id="priceMatrix_container" class="column-container">
      <typography variant="mat-caption-1" weight="regular" id="priceMatrix_title" class="column-title">
        {{appStrings.accounts_priceMatrix}}
      </typography>
      @if (accountDetails.priceMatrix) {
        <typography variant="mat-body-2" weight="bold" id="priceMatrix_value">
          {{accountDetails.priceMatrix}}
        </typography>
      }
      @if (!accountDetails.priceMatrix) {
        <typography variant="mat-body-2" weight="bold" id="priceMatrix_noValue">
          -
        </typography>
      }
    </div>
    <div id="paymentTerms_container" class="column-container">
      <typography variant="mat-caption-1" weight="regular" id="paymentTerms_title" class="column-title">
        {{appStrings.accounts_PaymentTerms}}
      </typography>
      @if (accountDetails.paymentTerms) {
        <typography variant="mat-body-2" weight="bold" id="paymentTerms_value">
          {{accountDetails.paymentTerms}}
        </typography>
      }
      @if (!accountDetails.paymentTerms) {
        <typography variant="mat-body-2" weight="bold" id="paymentTerms_noValue">
          -
        </typography>
      }
    </div>
    <div id="creditLimit_container" class="column-container">
      <typography variant="mat-caption-1" weight="regular" id="creditLimit_title" class="column-title">
        {{appStrings.accounts_availableCredit}}
      </typography>
      <typography variant="mat-body-2" weight="bold" id="creditLimit_value">
        {{accountDetails.hasAvailableCredit}}
      </typography>
    </div>
    <div id="billToAddress_container" class="column-container">
      <typography variant="mat-caption-1" weight="regular" id="billToAddress_title" class="column-title">
        {{appStrings.accounts_billToAddress}}
      </typography>
      @if (accountDetails.billToAddress) {
        <typography variant="mat-body-2" weight="bold" id="billToAddress_value">
          {{accountDetails.billToAddress}}
        </typography>
      }
      @if (!accountDetails.billToAddress) {
        <typography variant="mat-body-2" weight="bold" id="billToAddress_noValue">
          -
        </typography>
      }
    </div>
    <div id="shipToAddress_container" class="column-container">
      <typography variant="mat-caption-1" weight="regular" id="shipToAddress_title" class="column-title">
        {{appStrings.accounts_shipToAddress}}
      </typography>
      @if (accountDetails.shipToAddress) {
        <typography variant="mat-body-2" weight="bold" id="shipToAddress_value">
          {{accountDetails.shipToAddress}}
        </typography>
      }
      @if (!accountDetails.shipToAddress) {
        <typography variant="mat-body-2" weight="bold" id="shipToAddress_noValue">
          -
        </typography>
      }
    </div>
    <div id="lnNotes_container" class="column-container">
      <typography variant="mat-caption-1" weight="regular" id="lnNotes_title" class="column-title">
        {{appStrings.accounts_lnNotes}}
      </typography>

      <ds-link weight="bold" variant="link-2" id="lnNotes_button" linkRef="null" (click)="onNotesClick($event)">
        {{appStrings.button_view}}
      </ds-link>
    </div>
  </div>
</ds-paper>

<ds-dialog
  [title]="appStrings.accounts_lnNotes"
  [description]="dialogText"
  [actionButtons]="dialogButtons"
  [open]="dialogOpen$">
</ds-dialog>